export function calculatePaymentPercentage (parts) {
  if (!parts || !parts.length) return 0

  const totals = parts.reduce((acc, part) => {
    acc.current += Number(part.currentPriceCents || 0)
    acc.signed += Number(part.signedPriceCents || 0)
    acc.adjusted += Number(part.adjustedPriceCents || 0)
    return acc
  }, { current: 0, signed: 0, adjusted: 0 })

  const totalSignedAdjusted = totals.signed + totals.adjusted
  if (totalSignedAdjusted === 0) return 0

  return (totals.current / totalSignedAdjusted) * 100
}
